const useTablePaginationMixin = {
  data() {
    return {
      list: [],
      listQuery: {
        keyword: '',
        page: 1,
        size: 50,
        sizes: [50, 100],
        total: 0,
      },
      isLoading: true,
    }
  },
  methods: {
    handleSizeChange(size) {
      this.listQuery.size = size
      this.getList()
    },
    handlePageChange(page) {
      if (this.listQuery.page === page) {
        return
      }

      this.listQuery.page = page
      this.getList()
    },
  },
}

export default useTablePaginationMixin
